{
  "short": {
    "year": "numeric",
    "month": "short",
    "day": "numeric"
  },
  "long": {
    "year": "numeric",
    "month": "short",
    "day": "numeric",

    "hour": "numeric",
    "minute": "numeric"
  },
  "num": { "year": "numeric", "month": "numeric", "day": "numeric" },
  "time": { "hour": "numeric", "minute": "numeric" }
}
